const sicoobSchema = {
  account: {
    maxLength: 9
  }
};

module.exports = sicoobSchema;
